
export const specsaversPalette = {
    primary: { main: '#016C42', transparent: 'rgba(53, 222, 155, 0.1)' },
    error: { background: '#FDEBEB', main: '#C11E04', background2: "#FDE0E0" },
}